"use client"

import LayoutContent from "@/components/common/Layout/Content"
import { Col, Row } from "antd"
import { usePathname } from "next/navigation"

const BasicLayoutContent = ({ children, store, ...props }: any) => {
  const pathname = usePathname()
  const isAbout = pathname?.includes("/about") && (!!store.about?.bg_image || !!store.about?.bg_color)

  const shownBg = (isAbout ? store.about.bg_mode === 'fill' && !!store.about.bg_image : store.root_layout_bg.mode === 'fill' && !!store.root_layout_bg.image)

  const style = {
    ...props.style,
    ...(shownBg ? {
      backgroundImage: `url("${isAbout ? store.about.bg_image : store.root_layout_bg.image}")`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100vw 100vh',
      backgroundAttachment: 'fixed',
    } : {})
  }

  return (
    <LayoutContent
      {...props}
      className='basic_layout--content'
      style={style}
    >
      {/* {shownBg && (
        <NextImage
          hiddenSpin
          src={isAbout ? store.about.bg_image : store.root_layout_bg.image}
          width={2000}
          height={2000}
          alt="Background main content"
          style={{
            objectFit: 'cover',
            position: 'fixed',
            width: '100vw',
          }}
          fetchPriority='high'
          className="basic_layout--content-bgimg"
        />
      )} */}
      {children}
    </LayoutContent>
  )
}

export default BasicLayoutContent